"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SendTestSms {
    static getAttributeTypeMap() {
        return SendTestSms.attributeTypeMap;
    }
}
SendTestSms.discriminator = undefined;
SendTestSms.attributeTypeMap = [
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    }
];
exports.SendTestSms = SendTestSms;
//# sourceMappingURL=sendTestSms.js.map